import { matchPath, useLocation } from 'react-router-dom'

export default function useCheckActiveNav() {
  const { pathname } = useLocation()

  const checkActiveNav = (path: string) => {
    return !!matchPath(`${path}/*`, pathname)
    // !!matchPath(path, pathname) ||
    // !!matchPath(`${path}/:[slug]`, pathname)
  }

  return { checkActiveNav }
}
